import { Route, Routes } from "react-router-dom";
import RouteScrollToTop from "../helper/RouteScrollToTop";
import HomePage from "../pages/home/HomePage";
import ProductPage from "../pages/product/ProductPage";
import SearchProductPage from "../pages/product/SearchProductPage";
import ProductDetailsPage from "../pages/product/ProductDetailsPage";
import CartPage from "../pages/account/CartPage";
import CheckoutPage from "../pages/account/CheckoutPage";
import FreeDeliveryPage from "../pages/free-delivery/FreeDeliveryPage";
import AccountPage from "../pages/account/AccountPage";
import ContactPage from "../pages/contact/ContactPage";
import PhosphorIconInit from "../helper/PhosphorIconInit";
import BecomeSellerPage from "../pages/become-seller/BecomeSellerPage";
import WishlistPage from "../pages/account/WishlistPage";
import LoginPage from "../pages/account/LoginPage";
import RegisterPage from "../pages/account/RegisterPage";
import PrivateRoute from "../components/auth/PrivateRoute";
import DynamicContentPage from "../pages/dynamic-content/DynamicContentPage";
import PaymentSuccessPage from "../pages/account/PaymentSuccessPage";
import TrackingPage from "../pages/tracking/TrackingPage";

import useJWT from "../hooks/useJWT";
import OrderDetailPage from "../pages/account/OrderDetailPage";
import TermsAndCondition from "../pages/terms-and-condition/TermsandCondition";

// const LanguageRouter = () => {
//   const { lang } = useParams();
//   const { isLoggedIn } = useJWT();

//   return (
//     <Routes>
//       {/* Public Routes */}
//       <Route element={<PublicLayout />}>
//         <Route path="login" element={<LoginPage lang={lang} />} />
//         <Route path="register" element={<RegisterPage lang={lang} />} />
//         <Route path="help" element={<HelpPage lang={lang} />} />
//       </Route>

//       {/* Protected Routes */}
//       <Route
//         element={
//           isAuthenticated ? <ProtectedLayout /> : <Navigate to={`/${lang}/login`} />
//         }
//       >
//         <Route path="dashboard" element={<Dashboard lang={lang} />} />
//         <Route path="settings" element={<Settings lang={lang} />} />
//       </Route>

//       {/* Catch-all */}
//       {/* <Route path="*" element={<NotFound />} /> */}
//     </Routes>
//   );
// };

const AppRouter = () => (
  <>
    <RouteScrollToTop />
    <PhosphorIconInit />

    <Routes>
      <Route exact path="/" element={<HomePage />} />
      <Route exact path="/login" element={<LoginPage />} />
      <Route exact path="/register" element={<RegisterPage />} />
      <Route exact path="/products" element={<ProductPage />} />
      <Route exact path="/search" element={<SearchProductPage />} />
      <Route exact path="/product-details" element={<ProductDetailsPage />} />
      <Route
        exact
        path="/product-details/:slug"
        element={<ProductDetailsPage />}
      />
      <Route
        exact
        path="/become-seller"
        element={<ProductPage isWholesale={true} />}
      />
      <Route
        exact
        path="/wholesale-price"
        element={<ProductPage isWholesale={true} />}
      />
      <Route
        exact
        path="/wholesale/products"
        element={<ProductPage isWholesale={true} />}
      />
      <Route
        exact
        path="/wholesale/search"
        element={<SearchProductPage isWholesale={true} />}
      />
      <Route
        exact
        path="/wholesale/product-details"
        element={<ProductDetailsPage isWholesale={true} />}
      />
      <Route
        exact
        path="/wholesale/product-details/:slug"
        element={<ProductDetailsPage isWholesale={true} />}
      />
      {/* <Route exact path="/free-delivery" element={<FreeDeliveryPage />} /> */}
      <Route
        exact
        path="/cart"
        element={
          <PrivateRoute>
            <CartPage />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path="/payment/complete"
        element={
          <PrivateRoute>
            <PaymentSuccessPage />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path="/checkout"
        element={
          <PrivateRoute>
            <CheckoutPage />
          </PrivateRoute>
        }
      />

      {/* <Route exact path="/wishlist" element={<WishlistPage />} /> */}
      <Route exact path="/tracking" element={<TrackingPage />} />
      <Route exact path="/:type" element={<DynamicContentPage />} />
      <Route
        exact
        path="/account"
        element={
          <PrivateRoute>
            <AccountPage />
          </PrivateRoute>
        }
      />
      <Route
        exact
        path="/order-detail"
        element={
          <PrivateRoute>
            <OrderDetailPage />
          </PrivateRoute>
        }
      />
      <Route exact path="/contact" element={<ContactPage />} />
      <Route exact path="/term-and-condition" element={<TermsAndCondition />} />
    </Routes>
  </>
);

export default AppRouter;
